import PropTypes from 'prop-types';

const propType = {
  tax: PropTypes.number,
  price: PropTypes.number,
  total: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  vat: PropTypes.number,
  rate: PropTypes.number,
  code: PropTypes.string,
  symbol: PropTypes.string,
  billingCountry: PropTypes.string,
  userCountry: PropTypes.string,
  billingType: PropTypes.oneOf(['individual', 'company']),
  priceWithoutVAT: PropTypes.bool,
};

export default { propType };
